<script lang="ts" setup>
import NewHeader from '@/components/NewHeader.vue';
import NewFooter from '@/components/NewFooter.vue';
import { useRouter, useRoute } from 'vue-router';
import LoginWithGoogle from '~/components/LoginWithGoogle.vue';
import LoginWithEmail from '~/components/LoginWithEmail.vue';

const { t } = useI18n();
const utils = useUtils();
const localePath = useLocalePath();
const route = useRoute();
const authStore = useAuthStore();

if (process.client && authStore.isLogin) {
    navigateTo(localePath('/'));
}

const supportedSites = ['google'];
if (!route.params.site || !supportedSites.includes(route.params.site as string)) {
    // 如果没有 site 参数，重定向到 /login/google
    navigateTo('/login/google');
}

const loginFormVisible = ref(true);

// 接受路由中的token并触发登录操作
// SEO 元数据
useHead({
    title: t('login.page_title'),
    meta: [
        {
            name: 'description',
            content: t('login.meta_description')
        }
    ]
});

watchEffect(async () => {
    if (route.query.token && route.query.uid) {
        loginFormVisible.value = false;
        // 获取 redirect 参数，如果没有就默认跳转到 '/my/account'
        const redirect = route.query.redirect as string || '/my/account';
        await utils.loginByToken(route.query.token as string, redirect);
    }
});

</script>

<template>
    <div>
        <NewHeader />
        <div class="flex flex-1 bg-[url('@/assets/images/login-bg.png')] bg-cover relative items-center justify-center min-h-dvh">
            <div class="back-mask w-full h-full flex items-center justify-center bg-cover overflow-auto">
                <div v-if="loginFormVisible" class="login-form m-auto flex flex-col items-center bg-neutral-900 p-5 lg:p-7 rounded-2xl max-w-[450px] mx-4 w-full sm:w-auto my-20 lg:my-24">
                    <NuxtLink :to="localePath('/')" class="flex items-center">
                        <img class="h-8 w-8" src="/idx/bestfaceswap-logo.svg" :alt="t('common.logo_alt')" />
                    </NuxtLink>
                    <div class="title font-bold text-center text-xl my-5">{{ t("common.modals.titles.login-required") }}</div>
                    <LoginWithGoogle />
                    <div class="separator flex items-center gap-2 my-2 w-full">
                        <hr class="flex-1 border-neutral-600" />
                        <span class="text-neutral-500">{{ t("common.login_or") }}</span>
                        <hr class="flex-1 border-neutral-600" />
                    </div>
                    <LoginWithEmail />
                    <div class="desc text-white/60 mt-3">
                        {{ t("common.agree_terms_start") }}
                        <NuxtLink :to="localePath('/terms')" class="underline font-semibold">
                            {{ t("common.terms_service") }}
                        </NuxtLink> {{ t("common.and") }}
                        <NuxtLink :to="localePath('/policy')" class="underline font-semibold">
                            {{ t("common.privacy_policy") }}
                        </NuxtLink>
                    </div>
                </div>
            </div>
        </div>
        <NewFooter />
    </div>
</template>

<style lang="scss" scoped></style>